import React, { Component } from "react";
import CycleFilterContextProvider from "./context/CycleFilterContext";
import CycleFilter from "./CycleFilter";
import OverviewContextProvider from "./context/OverviewContext";
import PVAOverviewContextProvider from "./context/PVAOverviewContext";
import PVAView from "./PVAView";
import OverviewView from "./OverviewView";
import CapabilityContextProvider from "./context/CapabilityContext";
import PageHeader from "../PageHeader";
import { PAGE_HEADERS } from "../util/Constants";

class Overview extends Component {
  render() {
    return (
      <CapabilityContextProvider>
        <PageHeader {...PAGE_HEADERS.SORT} />
        <CycleFilterContextProvider>
          <CycleFilter />
          <PVAOverviewContextProvider>
            <OverviewContextProvider>
              <OverviewView />
            </OverviewContextProvider>
            <PVAView pva={{ processName: "inbound" }} />
          </PVAOverviewContextProvider>
        </CycleFilterContextProvider>
      </CapabilityContextProvider>
    );
  }
}

export default Overview;



// WEBPACK FOOTER //
// ./src/components/overview/Overview.js